export default __webpack_public_path__ + "static/media/logo02-1.fc236eae.png";